import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { sanitizeAnearHtml } from '../../Utils/sanitizeAnearHtml'
import {
  contentColumnShellSx,
  eventFrameColumnSx
} from '../../UI/contentColumn'
import { DefaultContent } from './constants'

// The visual frame that renders HTML from the event app
const AppDisplay = React.memo(
  ({ anearEvent, html, frameContentRef, childAppsContainerRef }) => (
    <Box sx={{
      ...contentColumnShellSx,
      alignItems: 'flex-start',
      height: '100svh',
      overflow: 'hidden',
      //
      // Hairline gap under the header. Keep this small — the page chrome is dark,
      // so a larger pad reads as a bright slash when anything light shows through.
      //
      paddingTop: 0.25
    }}>
      <Box
        className="anear-event-frame"
        data-anear-event-frame=""
        // Camera viewfinder mounts here (not document.body) so the Anear header
        // stays visible while capture quality is unchanged.
        sx={eventFrameColumnSx}
      >
        {html === DefaultContent ? (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}>
            <CircularProgress size="5rem" />
          </Box>
        ) : (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}>
            {/* Parent event HTML - gets updated via dangerouslySetInnerHTML */}
            <div
              id={anearEvent.id}
              ref={frameContentRef}
              dangerouslySetInnerHTML={{ __html: sanitizeAnearHtml(html) }}
              style={{ width: '100%', height: '100%', overflow: 'auto' }}
            />
            {/* Child apps container - peers to parent content, not affected by dangerouslySetInnerHTML */}
            <div
              ref={childAppsContainerRef}
              id={`anear-child-apps-container-${anearEvent.id}`}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                pointerEvents: 'none', // Allow clicks to pass through to parent content by default
                zIndex: 99999, // Very high z-index to ensure child apps appear above parent content
                isolation: 'isolate', // Create own stacking context
                /*
                  IMPORTANT: Contain child-app "position: fixed" widgets to the EventFrame
                  instead of the window viewport (prevents widgets floating over the ABR header,
                  and makes behavior consistent across browsers).
                 */
                transform: 'translateZ(0)',
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  ),
  (prev, next) => prev.html === next.html
)

export default AppDisplay
